// Re-exported from @zag/core/models — departments moved to core domain.
export { DEPARTMENT_TRANSLATABLE_FIELDS, createDepartmentSchema, departmentQuerySchema, updateDepartmentSchema } from '@zag/core/models';
export type {
  CreateDepartment,
  DepartmentQuery,
  DepartmentResponse,
  DepartmentTranslatableField,
  DepartmentTranslations,
  UpdateDepartment,
} from '@zag/core/models';
